module.exports = __webpack_public_path__ + "3b3fcfb40964bb9cf13378ce93c3fc48.svg";